import React, { useEffect, useState } from "react";
import {Services} from "../network/Services";
import SearchDropdown from "./CustomComponent";
import Loader from "./Loader";
import AoUrl from "../network/url";

import formatUSPhoneNumber, { formatPhoneNumber, newPhoneNumberFormat, separateCountryCodeAndNumber,lplSubtinent,isValidFuntion, isNotValidNullUndefile } from "../control/Constant";
import { useConfirm } from "./ConfirmationToaster";
import CustomModal from "./CustomModal";
import withOccurrenceApi from "./withOccurrenceApi";

const AddNewUser = ({setSearchtext,userList,setSelecteduser,selectedUser,updateUser,reference,referencePage,setToast,subtenantId,timeMatter,setMatterNumber,setTimematter, queryData,textTmpObj,emailTmpObj,sentMail,commChannelId,noUpdate}) =>{
    const [userDetails,setUserdetails] = useState({fName:'',lName:'',email:'',contact:'',countryCode:'+1',matno:""})
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editClick, setEditClick] = useState(false);
    const [useLoader, setuseLoader] = useState(false)
    const [isModal, setisModal] = useState(false)
    const [occurenceUrl, setOccurenceUrl] = useState()
    const [isClientPermissions, setIsClientPermissions] = useState(false);
     const confirm = useConfirm();
    useEffect(()=>{
      let {countryCode,number} = separateCountryCodeAndNumber(selectedUser?.primaryMobile)
     if(isValidFuntion(selectedUser)){
       const [fName, lName] = (selectedUser?.fullName || "").split(" ");
       setUserdetails({
         fName:fName || '',
         lName:lName || '',
         email:selectedUser.primaryEmail,
         contact:formatUSPhoneNumber(number),
         countryCode:countryCode,
         matno : selectedUser?.matNo,
         contactStatus : selectedUser?.contactStatus
       })

     }
    },[selectedUser])

    useEffect(()=>{
      if(isNotValidNullUndefile(selectedUser?.userId)){
        fetchPermissions(selectedUser?.userId)
      }
    },[selectedUser])

  const fetchPermissions = async (userId) => {
    let notifiy = await getSMSNotificationPermissions(userId, setIsClientPermissions);
  }


  const fetchRole = async (userIds) => {
    let loggedInUserId = sessionStorage.getItem('loggedUserId')
    if (!loggedInUserId) return;
    const _resultOf = await Services.getUserRolesByUserId(userIds);
    if (_resultOf != 'err' && _resultOf?.data?.length > 0) {
      const resData = _resultOf?.data[0];

      const { signUpPlatform, id, userId } = resData;


      const jsonUserActivation = { "userRegstrtnId": id, "userId": userId, "signUpPlatform": signUpPlatform, "createdBy": loggedInUserId, "clientIPAddress": "::1" }
        ;
      Services.getCommonApi('POST', AoUrl.getUserActivationLink, jsonUserActivation).then((_resultGetActivationLink) => {
        if (_resultGetActivationLink != 'err') {
          setOccurenceUrl(_resultGetActivationLink?.data?.data?.activationURL)
        }
      }).catch((err) => { });
    } else {
    }
  }
    useEffect(() => {
      window.setEditClickGlobal = (value) => {
        setEditClick(value);
        window.editMode = value;
      };
      window.getUserDetails = () => userDetails;
      window.isViewOnlyMode = () => isValidFuntion(selectedUser.memberId);
      window.handleSaveGlobal = handleSaveClick;
      window.handleCancelGlobal = handleCancelClick;
      window.addUserGlobal = () => {
    if (!isValidFuntion(selectedUser.memberId)) {
      addUser();
    }
  };

      window.isEditClicked = editClick;
    }, [userDetails, editClick, selectedUser]);

    const handleChange = (key,value) =>{
    if(key == 'contact'){
      setUserdetails((prev)=>({...prev,[key]:formatUSPhoneNumber(value)}))
      return
    }
    setUserdetails((prev)=>({...prev,[key]:value}))
    }


    const addUser = () => {
      if (isSubmitting) return;
      setIsSubmitting(true);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if(userDetails?.fName == ''){
      setToast({message:`Please enter the first name`,type:"error"})
      setIsSubmitting(false);
      return;
    }
    if(userDetails?.lName == ''){
      setToast({message:`Please enter the last name`,type:"error"})
      setIsSubmitting(false);
      return;
    }
    if(userDetails?.email == ''){
      setToast({message:`Please enter the email`,type:"error"})
      setIsSubmitting(false);
      return;
    }

    if(!emailRegex.test(userDetails.email)){
      setToast({message:`Please enter the valid email`,type:"error"})
      setIsSubmitting(false);
      return;
    }
    if(userDetails?.contact == ''){
      setToast({message:`Please enter the contact`,type:"error"})
      setIsSubmitting(false);
      return;
    }
    // if(userDetails?.matno == ''){
    //   setToast({message:`Please enter the mat number`,type:"error"})
    //   setIsSubmitting(false);
    //   return;
    // }


    let jsonObj = {
      "subtenantId":reference == 'agingoption' ? 3 : subtenantId,
      "signUpPlateform":17,
      "createUserCredentials":true,
      // "createdBy":"univresalPayment",
      "user":{
        "roleId":10,
        "firstName":userDetails?.fName,
        "lastName":userDetails?.lName,
        "emailAddress":userDetails?.email,
        "userName":userDetails.email,
        "contactStatus": userDetails.contactStatus,
        "countryCode":userDetails?.countryCode || "+1",
        "mobileNumber":userDetails?.contact.replace(/[\s()-]/g, ""),
        "activateUser":false,
        "autoConfirmEmail":false,
        "autoConfirmMobile":false,
        "servicePlanId":"1"
      }}
    setuseLoader(true)
    const addNewuserfunc = Services.addNewUserdataservice(jsonObj)
    setuseLoader(false)
    addNewuserfunc.then((res)=>{
      if (setTimematter) setTimematter(false);
      updateUser(res,userDetails,false)
      setIsSubmitting(false);
      // setMatterNumber()
    }).catch((err=>{
        err?.response?.data?.messages?.map((ele)=>{
           setToast({message:ele,type:"error"})
        })
        setIsSubmitting(false);
    }))
    }

    const handleEditClick = () => {
      setEditClick(true);
    };

    const handleSaveClick = async() => {
      setEditClick(false);
      setuseLoader(true)
     if(selectedUser.primaryEmail !== userDetails.email){
       const jsonObj = {
         "currentUserName": selectedUser?.primaryEmail,
         "newUserName": userDetails.email,
         "updatedBy": selectedUser?.memberId,
         "remarks": "Client Primary Email Updated by Legal",
         "clientIPAddress": "::1",
         "isParaResquest": true
       }
       if(selectedUser?.isUserActive == true){
          setuseLoader(false)
         const userRes = await confirm(true,"Are you sure you want to change the email? If confirm, a reactivation link will be automatically sent to the client's account after the email is updated.",
           "Confirmation","custom",
           [
             {
               label: "Cancel",
               value: false,
             },
             {
               label: "Proceed",
               value: true,
             },
           ]
         );
         if(userRes == true){
            setuseLoader(true)
          const reasult = await updateEmail(jsonObj)
            fetchRole(selectedUser?.memberId)
            setuseLoader(false)
            setisModal(true)
         }else{
          const isChange = true
          saveFinalDetails(isChange)
         }


       }else{
        const reasult = await updateEmail(jsonObj)
        saveFinalDetails()
       }
     }else{
        saveFinalDetails()
     }
    };
  const saveFinalDetails = async (changeEmail,isReload) => {
    const memberRes = await Services?.getMemberDetails(selectedUser?.memberId)
    setuseLoader(false)
    const existingData = memberRes?.data?.data?.member || {};
    let payload = {
      userId: selectedUser?.memberId,
      fName: userDetails?.fName,
      lName: userDetails?.lName,
      subtenantId: reference == 'agingoption' ? 3 : subtenantId,
      matNo: userDetails?.matno,
      contactStatus: userDetails?.contactStatus,
      UpdatedBy: selectedUser?.memberId
    };

    const finalPayload = {
      ...existingData,
      ...payload
    };
    setuseLoader(true)
    await Services?.upateMemberByuserID(finalPayload);
    const contactRes = await Services.getContact(selectedUser?.memberId);
    setuseLoader(false)
    const existing = contactRes?.data?.data;
    const updateContactPayload = {
      userId: existing?.userId,
      activityTypeId: "4",
      contact: {
        mobiles: existing?.contact?.mobiles?.map((m) => ({
          contactId: m.contactId,
          contactTypeId: m.contactTypeId,
          commTypeId: m.commTypeId,
          updatedBy: selectedUser?.memberId,
          mobileNo: (userDetails?.countryCode || "") + userDetails?.contact.replace(/[^0-9]/g, "")
        })) || []
      }
    };
    setuseLoader(true)
    await Services.updateContact(
      selectedUser?.memberId,
      updateContactPayload
    );
    setuseLoader(false)
    setSelecteduser((prev) => ({
      ...prev,
      fullName: userDetails.fName + " " + userDetails.lName,
      primaryEmail: changeEmail == true ? selectedUser?.primaryEmail :  userDetails.email,
      primaryMobile: (userDetails.countryCode || "") + userDetails.contact.replace(/[^0-9]/g, ""),
      matNo: userDetails.matno,
      contactStatus: userDetails.contactStatus
    }));
    if(isReload == true){
    window.location.reload();
    }
  }
  const updateEmail = (jsonObj) => {
    return new Promise((resolve, reject) => {
      setuseLoader(true);
      Services.putUpdateMemberEmail(jsonObj).then((res) => {
          setToast({message: "Email updated successfully.",type:"success"});
          setuseLoader(false);
          resolve(res);
        })
        .catch((err) => {
          setuseLoader(false);
          if (err?.response?.status === 400) {
            const msg = err.response.data?.messages?.[0] || "Validation error";
            setToast({message: msg,type:"error"});
            resolve(err.response);
            return;
          }
          setToast({message: "Something went wrong. Please try again.",type: "error"});
          reject(err);
        });
    });
  };


    const handleCancelClick = async() => {
      setEditClick(false);
      setSelecteduser(() => ({
        fullName: selectedUser.fullName || '',
        primaryEmail: selectedUser.primaryEmail || '',
        primaryMobile: selectedUser.primaryMobile || '',
        memberId: selectedUser.memberId || '',
        matNo: selectedUser.matNo || '',
        contactStatus: selectedUser.contactStatus || ''
      }));
    };
  const handleCloaseEmail = () => {
    setisModal(false)
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default keypress behavior for Tab and Enter keys
    }
  }

  const sentEmailText = () => {
    sentTextNMail(occurenceUrl)
  }
  const sentTextNMail = async (url) => {
    let loggedInUserId = sessionStorage.getItem('loggedUserId')
    const { textTemplateType, textTemplateId } = textTmpObj?.textTempData[0] || []
    const { templateType, emailSubject, templateId } = emailTmpObj?.emailTempData[0] || [];
    const emailTo = userDetails?.email;
    let textTo = `${userDetails?.countryCode} ${formatUSPhoneNumber(userDetails?.contact)}`;
    if (isClientPermissions != true) {
      textTo = ''
    }
    const emailJson = createSentEmailJsonForOccurrene({
      emailType: templateType,
      emailTo: emailTo,
      emailSubject,
      emailContent: document.getElementById('emailtemplate')?.innerHTML?.replaceAll("contenteditable", "nothing"),
      emailTemplateId: templateId,
      emailMappingTablePKId: loggedInUserId,
      emailStatusId: 1,
      emailMappingTablePKId: loggedInUserId,
      createdBy: loggedInUserId,
    })
    const textJson = createSentTextJsonForOccurrene({
      smsType: textTemplateType,
      textTo: textTo,
      textContent: document.getElementById('texttemplate')?.innerHTML,
      smsTemplateId: textTemplateId,
      smsMappingTablePKId: loggedInUserId,
      smsStatusId: 1,
      smsMappingTablePKId: loggedInUserId,
      createdBy: loggedInUserId,

    });

    setuseLoader(true)
    const _resultSentEmailtext = await sentMail(emailJson, textJson);
    setisModal(false)
    setuseLoader(false)
    if (_resultSentEmailtext == 'resolve') {
      const message = `Email ${commChannelId == 3 ? "and Text " : ''} Sent Successfully.`;
      setToast({message:message,type:"success"})
    }
    const isReload = true
    saveFinalDetails('',isReload)

  }
  const replaceTemplate = (temp, url) => {
    let subtenantName = sessionStorage.getItem('subtenantName');
    const userDetail = JSON.parse(sessionStorage.getItem("userLoggedInDetail"))
    let TemplateContent = temp;
    const uniqueLink = occurenceUrl;
    TemplateContent = TemplateContent?.replace("@@SUBTENANTNAME", subtenantName);
    TemplateContent = TemplateContent?.replace("@@ACTIVATE_LINK", uniqueLink);
    TemplateContent = TemplateContent?.replace("@@ACTIVATE_LINK", uniqueLink);
    TemplateContent = TemplateContent?.replace("@@USER", selectedUser?.fullName);
    TemplateContent = TemplateContent?.replace("@@OLDEMAILADDRESS", selectedUser?.primaryEmail);
    TemplateContent = TemplateContent?.replace("@@NEWEMAILADDRESS", userDetails?.email);

    return TemplateContent
  }

    return  <div className={referencePage == "lpl" ? "d-flex" : " p-6 d-flex"}>
      {useLoader &&  <Loader useLoader={useLoader} />}
          {/* <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 ms-2">Search</button> */}
          <div className="mt-3 flex flex-wrap gap-x-4 gap-y-4">
            <div className="w-full md:w-[49%]">
              <h3 className="block text-sm font-medium text-gray-700 mb-1">First Name<span className="text-red-600">*</span></h3>
              <input
                type="text"
                className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId) && !editClick) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder="Enter the First Name"
                value={userDetails?.fName}
                onChange={(e)=>handleChange('fName',e.target.value)}
                disabled={isValidFuntion(selectedUser.memberId) && !editClick}
              />
            </div>
            <div className="w-full md:w-[49%]">
              <h3 className="block text-sm font-medium text-gray-700 mb-1">Last Name<span className="text-red-600">*</span></h3>
              <input
                className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId) && !editClick) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder="Enter the Last Name"
                value={userDetails.lName}
                onChange={(e)=>handleChange('lName',e.target.value)}
                disabled={isValidFuntion(selectedUser.memberId) && !editClick}
              />
            </div>
            <div className="w-full md:w-[49%]">
              <h3 className="block text-sm font-medium text-gray-700 mb-1">Email<span className="text-red-600">*</span></h3>
              <input
                className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId) && !editClick) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder="Enter the Email"
                value={userDetails.email}
                onChange={(e)=>handleChange('email',e.target.value)}
                disabled={(isValidFuntion(selectedUser.memberId)) && !editClick}
              />
            </div>
            <div className="w-full md:w-[49%] flex flex-col gap-1">
              <h3 className="block text-sm font-medium text-gray-700">Contact Number<span className="text-red-600">*</span></h3>
              <div className="flex items-center gap-2">
                <select
                  className={`px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId) && !editClick) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                  value={userDetails.countryCode}
                  onChange={(e) => handleChange("countryCode", e.target.value)}
                  disabled={isValidFuntion(selectedUser.memberId) && !editClick}
                >
                  <option value="+1">+1 (US)</option>
                  <option value="+91">+91 (IN)</option>
                </select>
                <input
                  type="tel"
                  className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId)&& !editClick) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                  placeholder="Enter the Contact Number"
                  value={userDetails.contact}
                  onChange={(e) => handleChange("contact", e.target.value)}
                  disabled={isValidFuntion(selectedUser.memberId) && !editClick}
                />
              </div>
            </div>




             {referencePage == "lpl" && <div className="w-full md:w-[49%]">
              <h3 className="block text-sm font-medium text-gray-700 mb-1">Mat No</h3>
              <input
                type="text"
                className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId) && !editClick) ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder="Enter the Mat No"
                value={userDetails?.matno || ''}
                onChange={(e)=>handleChange('matno',e.target.value)}
                disabled={(isValidFuntion(selectedUser?.memberId)) && !editClick}
              />
              </div>}
              {referencePage == "lpl" && <div className="w-full md:w-[49%]">
              <h3 className="block text-sm font-medium text-gray-700 mb-1">Client Status</h3>
              <input
                type="text"
                className={`w-full px-3 py-2 border border-gray-300 rounded-md ${(isValidFuntion(selectedUser.memberId)) && !editClick ? 'bg-gray-200 cursor-not-allowed' : ''}`}
                placeholder="Enter the Client Status"
                value={userDetails?.contactStatus}
                onChange={(e)=>handleChange('contactStatus',e.target.value)}
                disabled={isValidFuntion(selectedUser.memberId) && !editClick}
              />
            </div>}

          {(!isValidFuntion(selectedUser.memberId)) &&
          <div className="w-full mt-2 flex justify-end">
              <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700" onClick={()=>addUser()}>
                Submit
              </button>
            </div>
            }
          {(isValidFuntion(selectedUser.memberId) && (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator  !== 'true') && noUpdate != true) && (
            <div className="w-full mt-2 flex justify-end">
              {!editClick && (
                <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 me-3" onClick={handleEditClick}>
                  Edit
                </button>
              )}
              {editClick && (
                <>
                  <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 me-3" onClick={handleSaveClick}>
                    Save
                  </button>
                  <button className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700" onClick={handleCancelClick}>
                    Cancel
                  </button>
                </>
              )}
            </div>
          )}
          </div>

           {isModal &&  <>
              <CustomModal
                    open={isModal}
                    handleOpenModal={()=>handleCloaseEmail()}
                    header={'Preview Invite Template'}
                    size='lg'
                    backClick={() => console.log('backClick')}
                    refrencePage='InviteSpouse'
                    sentBtnClick={sentEmailText}
                >

          <div contentEditable className="w-full max-w-full block min-h-[50vh] max-h-[60vh] h-screen overflow-y-auto overflow-x-auto outline-none">
            <div id="emailtemplate-wrapper" className="relative w-full" onKeyDown={handleKeyDown}>
              <div className="w-full">
                <div id="emailtemplate" contentEditable="true" dangerouslySetInnerHTML={{ __html: replaceTemplate(emailTmpObj?.emailTemp) || "" }} className="w-full p-0 m-0 break-words" />
              </div>

              <div className="mt-0 m-5 w-full">
                <div id="texttemplate" contentEditable="true" dangerouslySetInnerHTML={{ __html: replaceTemplate(textTmpObj?.textTemp) || "" }} className="w-full p-0 m-0 break-words" />
              </div>
            </div>
          </div>
             </CustomModal>
            </>}

          </div>
}

// export default AddNewUser;

export default withOccurrenceApi(AddNewUser, 34);

export const getSMSNotificationPermissions = (primaryMemberUserId, setState) => {
  const questionId = 230
  const URL = AoUrl.getSubjectResponse + primaryMemberUserId + `/0/0/${questionId}`;
  return new Promise((resolve, reject) => {
    Services.getCommonApi('GET', URL, '').then((res) => {
      if (res) {
        const userSubjectsData = res.data?.data?.userSubjects;
        if (userSubjectsData?.length > 0 && userSubjectsData[0].response == 'true') {
          setState(true);
          resolve(true);
        } else {
          setState(false);
          resolve(false);
        }
      } else {
        setState(false)
        resolve(false); // Reject with error object
      }
    });
  });
}
export const createSentEmailJsonForOccurrene = ({ emailType, emailTo, emailSubject, emailContent, emailTemplateId, emailMappingTablePKId, emailBcc, emailcc, createdBy }) => {
  return {
    emailType: emailType ?? null,
    emailTo: emailTo ?? null,
    emailSubject: emailSubject ?? null,
    emailContent: emailContent ?? null,
    emailTemplateId: emailTemplateId ?? null,
    emailStatusId: 1,
    emailMappingTable: "tblUsers",
    emailMappingTablePKId: emailMappingTablePKId ?? null,
    emailBcc: emailBcc ?? null,
    emailcc: emailcc ?? null,
    createdBy: createdBy ?? null
  };
}

export const createSentTextJsonForOccurrene = ({ smsType, textTo, textContent, smsTemplateId, smsMappingTablePKId, createdBy }) => {
  return {
    smsType: smsType ?? null,
    textTo: textTo ?? null,
    textContent: textContent ?? null,
    smsTemplateId: smsTemplateId ?? null,
    smsStatusId: 1,
    smsMappingTable: "tblUsers",
    smsMappingTablePKId: smsMappingTablePKId ?? null,
    createdBy: createdBy ?? null,
  }
}